import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  DrawerContext,
  IconRegularChevronDown,
} from '@notino/react-styleguide';
import { GetReviewsQuery } from '@notino/shared/definitions/types';

import { useIsDesktop } from '@utils/helpers';

import messages from '../../../../../../messages';
import { ReviewsPlural } from '../../../ReviewsPlural';
import { DrawerTitle } from '../components/Title';
import { sortFilterBarMessages } from '../messages';
import { useReviewSortingStore } from '../Stores/sortingStore';
import { DrawerWrapper } from '../styled';

import { DrawerContent } from './DrawerContent';
import {
  DisplayedReviewsRange,
  SelectWrapper,
  SortByWrapper,
  SortingWrapper,
} from './styled';

interface SortingProps {
  reviewsData: NonNullable<GetReviewsQuery['reviewsAndFilters']>['data'];
}

export const Sorting: React.FC<SortingProps> = ({ reviewsData }) => {
  const { formatMessage } = useIntl();

  const isDesktop = useIsDesktop();

  const { openDrawer } = DrawerContext.useDrawerContext();

  const { orderBy: currentOrderBy, orderDesc: currentOrderDesc } =
    useReviewSortingStore();

  if (!reviewsData) {
    return null;
  }

  const { reviews, totalReviews } = reviewsData;

  return (
    <SortingWrapper>
      <DisplayedReviewsRange>
        <FormattedMessage
          {...(isDesktop
            ? sortFilterBarMessages.displayedRangeDesktop
            : sortFilterBarMessages.displayedRangeMobile)}
          values={{
            from: reviews.length > 0 ? 1 : 0,
            to: reviews.length,
            total: totalReviews,
          }}
        />{' '}
        <ReviewsPlural productReviewCount={totalReviews} />
      </DisplayedReviewsRange>
      <SortByWrapper>
        <>
          <FormattedMessage {...sortFilterBarMessages.sortByLabel} />:
        </>

        <SelectWrapper
          role="combobox"
          onClick={() => {
            openDrawer(
              <DrawerWrapper>
                <DrawerContent />
              </DrawerWrapper>,
              {
                title: (
                  <DrawerTitle
                    name={formatMessage(sortFilterBarMessages.sortByLabel)}
                  />
                ),
                initialPosition: 'dynamic',
                isTitleBorderHidden: true,
                hideScrollbar: true,
                showCloseIcon: false,
              }
            );
          }}
        >
          {formatMessage(
            messages[
              `orderReviewsBy${currentOrderBy}${
                currentOrderDesc ? 'Desc' : 'Asc'
              }`
            ]
          )}
          <IconRegularChevronDown height="1rem" width="1rem" />
        </SelectWrapper>
      </SortByWrapper>
    </SortingWrapper>
  );
};
